const record = (v) => typeof v === 'object' && v !== null;
export const isReviewOrganization = (v) => record(v) &&
    typeof v.id === 'string' &&
    typeof v.code === 'string' &&
    typeof v.name === 'string' &&
    ['cooperative', 'committee'].includes(String(v.kind)) &&
    typeof v.operationalEnabled === 'boolean' &&
    Array.isArray(v.permissions) &&
    v.permissions.every((p) => typeof p === 'string');
export const isReviewAffiliation = (v) => record(v) &&
    ['id', 'organizationId', 'memberId', 'memberName'].every((k) => typeof v[k] === 'string') &&
    ['active', 'inactive'].includes(String(v.status)) &&
    Number.isInteger(v.version) &&
    Number(v.version) > 0 &&
    [v.joinedOn, v.endedOn].every((d) => d === null || typeof d === 'string');
export const isReviewOrganizations = (v) => record(v) &&
    v.schemaVersion === 1 &&
    v.testOnly === true &&
    Array.isArray(v.items) &&
    v.items.every(isReviewOrganization);
export const isReviewAffiliations = (v) => record(v) &&
    v.schemaVersion === 1 &&
    v.testOnly === true &&
    typeof v.organizationId === 'string' &&
    Array.isArray(v.items) &&
    v.items.every((r) => isReviewAffiliation(r) && r.organizationId === v.organizationId);
export const isReviewHistory = (v) => Array.isArray(v) &&
    v.every((r) => record(r) &&
        typeof r.action === 'string' &&
        typeof r.at === 'string' &&
        typeof r.actorId === 'string' &&
        (r.reason === null || typeof r.reason === 'string') &&
        (r.before === null || isReviewAffiliation(r.before)) &&
        isReviewAffiliation(r.after));
